import cx from 'classnames';
import React, { useRef, useState } from 'react';
import { Icon, IconColor, IconSize } from '../../icon';
import { getElementPosition } from '../base-control/base-control.util';
import styles from './font-formatter.module.scss';
export const FontFormatterItem = ({ icon, label, onSelect, isSelected, index, disabled, classNames, preserveIconColor, ...restProps }) => {
    var _a, _b, _c, _d;
    const [isHover, setIsHover] = useState(false);
    const itemRef = useRef(null);
    const initialItemStyle = cx((_a = classNames === null || classNames === void 0 ? void 0 : classNames.segmentedItem) !== null && _a !== void 0 ? _a : styles.segmentedItem, { [(_b = classNames === null || classNames === void 0 ? void 0 : classNames.selected) !== null && _b !== void 0 ? _b : styles.selected]: isSelected }, { [(_c = classNames === null || classNames === void 0 ? void 0 : classNames.isIcon) !== null && _c !== void 0 ? _c : styles.isIcon]: !!icon }, { [(_d = classNames === null || classNames === void 0 ? void 0 : classNames.disabled) !== null && _d !== void 0 ? _d : styles.disabled]: disabled });
    const onClickHandler = (event) => {
        if (!disabled) {
            const position = getElementPosition(event.target);
            onSelect(index, position);
        }
    };
    const getIconColor = () => {
        if (preserveIconColor) {
            return IconColor.GRAY;
        }
        return isSelected || isHover ? IconColor.BLUE : IconColor.GRAY;
    };
    return (React.createElement("button", { type: "button", className: initialItemStyle, ...restProps, ref: itemRef, onClick: onClickHandler, onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false) },
        React.createElement(Icon, { id: icon, size: IconSize.LARGE, className: styles.innerIcon, color: getIconColor() })));
};
//# sourceMappingURL=font-formatter-item.js.map